import { EntityService } from './EntityService';
import { IEntity } from '../types';

export class GIAAActionStatusTypeService extends EntityService<IEntity> {
    public readonly parentEntities = [];
    protected childrenEntities = [];

    constructor() {
        super(`/GIAAActionStatusTypes`);
    }
}